import React, { useMemo, useState, Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  AppBar,
  Box,
  Button,
  Hidden,
  Toolbar,
  Tooltip,
  makeStyles,
  Typography,
  useTheme,
  Divider,
} from "@material-ui/core";
import { ArrowDropDown } from "@material-ui/icons";
import Logo from "src/components/Logo";

import { useSelector } from "react-redux";

import MockToggle from "src/components/MockToggle";
import AuthenPopup from "src/components/PopUp/AuthenPopup";
import BrokerSelector from "src/components/BrokerSelector";
import BetaChip from "src/components/BetaChip";
import { BROKERS as BROKER_INFOS } from "src/context/constants/brokerInfo";
import useModalState from "src/hooks/useModalState";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "inherit",
    zIndex: theme.zIndex.drawer + 100,
    paddingTop: "10px",
  },
  toolbar: {
    height: 40,
  },
  link: {
    textDecoration: "none",
    fontWeight: theme.typography.fontWeightBold,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    textTransform: "none",
  },
  linkIcon: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  selectLanguage: {
    color: theme.palette.text.primary,
    border: theme.spacing(0),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  start: {
    padding: "8px 20px",
    color: "black",
    borderRadius: 4,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  primaryColor: {
    color: theme.palette.primary.main,
  },
  btnLabel: {
    fontFamily: "NotoSanThai",
  },
}));

const TopBar: React.FC = () => {
  const classes = useStyles();
  const [openPopup, setOpenPopup] = useState(false);
  const [initialPopup, setInitialPopup] = useState<"login" | "regis">("login");
  const [openBotTrade, onOpenBotTrade, onCloseBotTrade] = useModalState();

  const account = useSelector((state) => state.account);

  const theme = useTheme();

  const isLogin = useMemo(() => {
    return !!account.user;
  }, [account]);

  const onClickRegis = (e: any) => {
    setOpenPopup(true);
    setInitialPopup("regis");
  };

  const onClickLogin = (e: any) => {
    setOpenPopup(true);
    setInitialPopup("login");
  };

  const handleClose = () => {
    setOpenPopup(false);
  };

  const renderMobileTopBar = () => {
    return (
      <Fragment>
        <Toolbar className={classes.toolbar}>
          <RouterLink to="/">
            <Logo />
          </RouterLink>
          <MockToggle />
          <BetaChip />

          <Box flexGrow={1} />
          {!isLogin && (
            <Button variant="contained" color="primary" onClick={onClickRegis}>
              สมัคร
            </Button>
          )}
          <Box px={1} />
          {/* <BrokerSelector /> */}
        </Toolbar>
      </Fragment>
    );
  };

  const renderDesktopGuest = () => {
    return (
      <>
        <Box px={1} />
        <Button className={classes.start} onClick={onClickLogin} variant="text">
          <Typography
            variant="button"
            className={`${classes.primaryColor} ${classes.btnLabel}`}
          >
            เข้าสู่ระบบ
          </Typography>
        </Button>
        <Button
          className={classes.start}
          onClick={onClickRegis}
          variant="contained"
        >
          <Typography className={classes.btnLabel} variant="button">
            สมัคร
          </Typography>
        </Button>
      </>
    );
  };

  const renderMenu = () => {
    const isBitkub =
      account.user?.broker.name.toLowerCase() === BROKER_INFOS.bitkub.name;
    return (
      <>
        {isBitkub ? (
          // <Tooltip title="Coming soon" arrow>
          <Button className={classes.link} href="rebalance">
            <Typography className={classes.btnLabel} variant="button">
              บอทเทรด
            </Typography>
            {/* <ArrowDropDown /> */}
          </Button>
        ) : (
          // </Tooltip>
          <Button className={classes.link} href="explore">
            <Typography className={classes.btnLabel} variant="button">
              ค้นหาโมเดล
            </Typography>
          </Button>
        )}
        <Button className={classes.link} href="portfolio">
          <Typography className={classes.btnLabel} variant="button">
            พอร์ตของฉัน
          </Typography>
        </Button>
        {!isBitkub && account.user?.isApproved && (
          <Button className={classes.link} href="transaction">
            <Typography className={classes.btnLabel} variant="button">
              ฝาก/ถอน
            </Typography>
          </Button>
        )}
      </>
    );
  };

  const renderDesktopAuth = () => {
    return (
      <>
        <Box px={1} />
        {renderMenu()}
        <Button className={classes.link} href="account">
          <Typography className={classes.btnLabel} variant="button">
            จัดการบัญชี
          </Typography>
        </Button>
      </>
    );
  };

  const renderDesktopTopBar = () => {
    return (
      <Fragment>
        <Toolbar className={classes.toolbar}>
          <RouterLink to="/">
            <Logo />
          </RouterLink>
          <Box pr={1} />
          <MockToggle />
          <BetaChip />
          <Box flexGrow={1} />
          {isLogin ? renderDesktopAuth() : renderDesktopGuest()}
          {/* <Divider
            className={classes.divider}
            orientation="vertical"
            style={{ backgroundColor: "#494949" }}
            flexItem
          />
          <BrokerSelector /> */}
        </Toolbar>
      </Fragment>
    );
  };

  const appBarElevation = (): number => {
    return 0;
  };

  const appBarStyle = (): any => {
    var style: any = {
      zIndex: theme.zIndex.appBar,
      backgroundColor: theme.palette.background.default,
    };
    return style;
  };

  return (
    <Hidden>
      <AppBar
        className={classes.root}
        elevation={appBarElevation()}
        style={appBarStyle()}
      >
        <AuthenPopup
          open={openPopup}
          onClose={handleClose}
          initialPopup={initialPopup}
        />
        <Hidden lgUp>{renderMobileTopBar()}</Hidden>
        <Hidden mdDown>{renderDesktopTopBar()}</Hidden>
      </AppBar>
    </Hidden>
  );
};
export default TopBar;
